import { Correction } from '../../store/Correction';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getCorrection = (id: string) => {
  return apiService.callExternalApi<Correction>({
    url: `${API_SERVER_URL}/corrections/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const listCorrections = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'paidInRunDate', direction: 'desc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<Correction>>({
    url: buildAdvancedQueryURL(mergedFilters, 'corrections'),
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const createCorrection = (correctionData: Partial<Correction>) => {
  return apiService.callExternalApi<Correction>({
    url: `${API_SERVER_URL}/corrections`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: correctionData
  });
};

export const updateCorrection = (correctionData: Partial<Correction>) => {
  return apiService.callExternalApi<Correction>({
    url: `${API_SERVER_URL}/corrections/${correctionData.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    data: correctionData
  });
};

export const deleteCorrection = (id: string) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/corrections/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};
